export const CACHE_DATAGROUP_START = "mipro_pwa_cache_datagroup_start";
export const CACHE_URL_START = "mipro_pwa_cache_url_start";
export const CACHE_URL_END = "mipro_pwa_cache_url_end";
export const CACHE_COMPLETE = "mipro_pwa_cache_complete";
export const CACHE_COMPONENT_READY = "mipro_pwa_cache_component_ready";
